/* import __COLOCATED_TEMPLATE__ from './edit-link.hbs'; */
/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    openModal: () => void;
  };
}

const EditLink = templateOnlyComponent<Signature>();
export default EditLink;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Billing::Summary::CardElements::EditLink': typeof EditLink;
  }
}
